import { INVERTED_METRICS, type MetricKey } from "@/engine/types";

const LABELS: Record<MetricKey, string> = {
  schedule: "Schedule",
  budget: "Budget",
  quality: "Quality",
  teamTrust: "Team Trust",
  stakeholderTrust: "Stakeholder Trust",
  technicalDebt: "Technical Debt",
  operationalRisk: "Operational Risk",
};

const ICONS: Record<MetricKey, string> = {
  schedule: "⏱️",
  budget: "💰",
  quality: "🧪",
  teamTrust: "🤝",
  stakeholderTrust: "🏛️",
  technicalDebt: "🧱",
  operationalRisk: "🚨",
};

export function metricLabel(key: MetricKey): string {
  return LABELS[key];
}

export default function MetricBar({ metric, value }: { metric: MetricKey; value: number }) {
  const inverted = INVERTED_METRICS.includes(metric);
  const healthy = inverted ? 100 - value : value;
  const tone =
    healthy >= 70 ? "bg-emerald-500" : healthy >= 40 ? "bg-amber-500" : "bg-red-500";
  const atRisk = healthy < 40;

  return (
    <div>
      <div className="flex justify-between text-[11px] font-body text-muted-foreground mb-1">
        <span className="flex items-center gap-1">
          <span className="leading-none">{ICONS[metric]}</span>
          {LABELS[metric]}
          {atRisk && <span className="animate-pulse">⚠️</span>}
        </span>
        <span className="font-mono">{value}</span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${tone} ${atRisk ? "animate-pulse" : ""}`}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}
